import { memo } from 'react';
import { useFormikContext } from 'formik';
import { StatementsFormVM } from 'front-office/view-models/statements/statements-form';
import Deceased from 'front-office/components/shared/deceased';
import { Divider, Grid, useEventCallback } from '@mui/material';
import { DecasedFormVM } from 'front-office/view-models/certificate/deceased-form';
import PmiTextField from 'shell/components/shared/text-field';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';

const OtherSuccessionComponent = (): React.ReactElement => {
  const formContext = useFormikContext<StatementsFormVM>();

  const onFieldDecasedChange = useEventCallback(
    (key: keyof DecasedFormVM, value: DecasedFormVM[keyof DecasedFormVM]) => {
      formContext.setFieldValue('decased', {
        ...formContext.values.decased,
        [key]: value,
      });
    }
  );

  const onFieldsDeceasedChange = useEventCallback((values: DecasedFormVM) => {
    formContext.setFieldValue('decased', {
      ...formContext.values.decased,
      ...values,
    });
  });

  return (
    <Grid item container spacing={2}>
      <Grid item xs={12}>
        <Deceased
          onFieldDecasedChange={onFieldDecasedChange}
          decased={formContext.values.decased}
          onFieldsDeceasedChange={onFieldsDeceasedChange}
        />
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <PmiTitleDivider>Eredi</PmiTitleDivider>
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          label="Dati eredi"
          aria-label="Dati eredi"
          id="heirs-note"
          fullWidth
          multiline
          inputProps={{
            spellCheck: true,
            lang: 'it',
          }}
          rows={5}
          value={formContext.values?.heirsNote || ''}
          onChange={(event) => {
            formContext.setFieldValue('heirsNote', event.target.value);
          }}
        />
      </Grid>
    </Grid>
  );
};

OtherSuccessionComponent.displayName = 'Other Succession component';

const OtherSuccession = memo(OtherSuccessionComponent);

export default OtherSuccession;
